const STORAGE_KEY = 'meet_distance_filter'

export const getDistanceFilter = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (!raw) return { miles: 10, lat: '', lng: '' }
        const parsed = JSON.parse(raw)
        return { miles: parsed.miles ?? 10, lat: parsed.lat ?? '', lng: parsed.lng ?? '' }
    } catch {
        return { miles: 10, lat: '', lng: '' }
    }
}

export const setDistanceFilter = ({ miles, lat, lng }) => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ miles, lat, lng }))
    } catch {
        // ignore — filter just won't persist across sessions
    }
}
